// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Dxi9","fullView":"styles_fullView__31umy"};